(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  window.addEventListener('scroll', () => {
    const header = document.querySelector('.section-header');
    if (header) {
      const isScrolled = window.scrollY > 0;
      header.classList.toggle('is-sticky', isScrolled);
      // Restores the native Dawn logo resizing behavior
      header.classList.toggle('scrolled-past-header', isScrolled);
    }
  }, { passive: true });

  } catch(e) { console.error(e); }
})();
})();
